import { RequestErrorReducer } from './types'

export const initialState: RequestErrorReducer = {
  code: 0,
  success: false,
  detail: '',
  name: ''
}
